import React from "react";

const CheckboxIcon = (props) => {
  return (<div className={`checkbox-icon ${props.error ? 'checkbox-error' : ''}`}></div>);
}

export default CheckboxIcon;
